module.exports = __webpack_public_path__ + "img/breath_logo.222dd172.jpg";